import React from 'react';
import { Outlet, useParams } from 'react-router';
import ArchivedLeagueBanner from '../components/ArchivedLeagueBanner';
import LscSettingsTabs from '../components/LscSettingsTabs';
import LoadingState from '../components/LoadingState';
import { LscAuthGate } from '../hooks/useLscAuthGate';
import { useLeague } from '../hooks/useLeague';
import { isLeagueArchived } from '../lifecycle';
import { lscReturnTo } from '../routing';
import { useLscContentColumn } from '../lscContentColumn';

const LscSettingsLayout: React.FC = () => {
  useLscContentColumn('narrow');
  const { leagueId } = useParams<{ leagueId: string }>();
  return (
    <LscAuthGate returnTo={lscReturnTo(`/leagues/${leagueId}/settings`)}>
      <SettingsLayoutContent />
    </LscAuthGate>
  );
};

function SettingsLayoutContent() {
  const { league, loading, isOperator } = useLeague();
  const { leagueId } = useParams<{ leagueId: string }>();

  if (loading) return <LoadingState />;

  const archived = league ? isLeagueArchived(league.status) : false;

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="space-y-4">
        <h1 className="text-2xl font-bold text-white">League settings</h1>
        {archived && <ArchivedLeagueBanner />}
        {leagueId ? (
          <LscSettingsTabs leagueId={leagueId} showAutomationTabs={Boolean(isOperator)} />
        ) : null}
      </div>
      <Outlet />
    </div>
  );
}

export default LscSettingsLayout;
